'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createIconComponent = require('./utils/createIconComponent');

var _createIconComponent2 = _interopRequireDefault(_createIconComponent);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconCompare = (0, _createIconComponent2.default)({ fillContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { fill: 'none', d: 'M.025 0h24v24h-24z', 'data-name': 'Invisible_Shape' }),
    _react2.default.createElement(
      'g',
      { 'fill-rule': 'evenodd' },
      _react2.default.createElement('path', { d: 'M4.625 19.75l2.25-1.15 2.2 1.2-.35-2.5 1.85-1.75-2.5-.4-1.1-2.3-1.15 2.25-2.55.35 1.8 1.8-.45 2.5z' }),
      _react2.default.createElement('path', { d: 'M22.825 0h-11.5a.555.555 0 0 0-.55.55v3.3h-4.55a.555.555 0 0 0-.55.55v4.3h-4.5a.555.555 0 0 0-.55.55V23.5a.548.548 0 0 0 .55.5h11.5a.555.555 0 0 0 .55-.55v-4.3h4.5a.555.555 0 0 0 .55-.55v-3.25h4.55a.555.555 0 0 0 .55-.55V.55a.555.555 0 0 0-.55-.55zm-10.7 22.9h-10.4V9.75h10.4zm5.05-4.85h-3.95v-3.635l.939.512-.35-2.5 1.85-1.75-2.439-.39V9.2a.555.555 0 0 0-.55-.55h-5.9v-3.7h10.4zm5.1-3.8h-4V10.6l1.054.575-.35-2.5 1.85-1.75-2.5-.4-.054-.114V4.4a.555.555 0 0 0-.55-.55h-5.85V1.1h10.4z' })
    )
  ), lightContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { fill: 'none', d: 'M.025 0h24v24h-24z', 'data-name': 'Invisible_Shape' }),
    _react2.default.createElement(
      'g',
      { 'fill-rule': 'evenodd' },
      _react2.default.createElement('path', { d: 'M4.625 19.75l2.25-1.15 2.2 1.2-.35-2.5 1.85-1.75-2.5-.4-1.1-2.3-1.15 2.25-2.55.35 1.8 1.8-.45 2.5z' }),
      _react2.default.createElement('path', { d: 'M22.825 0h-11.5a.555.555 0 0 0-.55.55v3.3h-4.55a.555.555 0 0 0-.55.55v4.3h-4.5a.555.555 0 0 0-.55.55V23.5a.548.548 0 0 0 .55.5h11.5a.555.555 0 0 0 .55-.55v-4.3h4.5a.555.555 0 0 0 .55-.55v-3.25h4.55a.555.555 0 0 0 .55-.55V.55a.555.555 0 0 0-.55-.55zm-10.7 22.9h-10.4V9.75h10.4zm5.05-4.85h-3.95v-3.635l.939.512-.35-2.5 1.85-1.75-2.439-.39V9.2a.555.555 0 0 0-.55-.55h-5.9v-3.7h10.4zm5.1-3.8h-4V10.6l1.054.575-.35-2.5 1.85-1.75-2.5-.4-.054-.114V4.4a.555.555 0 0 0-.55-.55h-5.85V1.1h10.4z' })
    )
  ), regularContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { fill: 'none', d: 'M.025 0h24v24h-24z', 'data-name': 'Invisible_Shape' }),
    _react2.default.createElement(
      'g',
      { 'fill-rule': 'evenodd' },
      _react2.default.createElement('path', { d: 'M4.625 19.75l2.25-1.15 2.2 1.2-.35-2.5 1.85-1.75-2.5-.4-1.1-2.3-1.15 2.25-2.55.35 1.8 1.8-.45 2.5z' }),
      _react2.default.createElement('path', { d: 'M22.825 0h-11.5a.555.555 0 0 0-.55.55v3.3h-4.55a.555.555 0 0 0-.55.55v4.3h-4.5a.555.555 0 0 0-.55.55V23.5a.548.548 0 0 0 .55.5h11.5a.555.555 0 0 0 .55-.55v-4.3h4.5a.555.555 0 0 0 .55-.55v-3.25h4.55a.555.555 0 0 0 .55-.55V.55a.555.555 0 0 0-.55-.55zm-10.7 22.9h-10.4V9.75h10.4zm5.05-4.85h-3.95v-3.635l.939.512-.35-2.5 1.85-1.75-2.439-.39V9.2a.555.555 0 0 0-.55-.55h-5.9v-3.7h10.4zm5.1-3.8h-4V10.6l1.054.575-.35-2.5 1.85-1.75-2.5-.4-.054-.114V4.4a.555.555 0 0 0-.55-.55h-5.85V1.1h10.4z' })
    )
  ), height: undefined, width: undefined, viewBox: "0 0 24 24" });
IconCompare.displayName = 'IconCompare';
exports.default = IconCompare;